import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../../components/ui/sheet.jsx";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar.jsx";
import { Button } from "../../components/ui/button";
import {
  setCurrentConversation,
  getDirectMessages,
  getGroupMessages,
  createDirectConversationId,
  createGroupConversationId,
  getConversationsList,
} from "../../../../../../Redux/Reducers/cceReducer.js";
import { getGroupMembers } from "../../../../../../Redux/Reducers/ContactReducer.js";

export default function SendNewMessage({ openDm, setOpenDm }) {
  const [dmTarget, setDmTarget] = useState(null);
  const [dmText, setDmText] = useState("");
  const [dmUserId, setDmUserId] = useState(null);
  const [dmGroupId, setDmGroupId] = useState(null);
  const [dmCategory, setDmCategory] = useState("people");
  const [profileEmail, setProfileEmail] = useState("");
  const Connectedcontact = useSelector(
    (state) => state?.ContactArray?.ConnectedContact
  );
  const ContactGroups = useSelector(
    (state) => state?.ContactArray?.ContactGroup
  );
  const userConverations = useSelector(
    (state) => state?.ContactArray?.allConversations
  );

  const filteredConversationsList = userConverations?.conversations;
  const dispatch = useDispatch();

  const handleStartChat = (item) => {
    // console.log("Starting chat with:", item);
    const title = item?.first_name
      ? `${item?.first_name} ${item?.last_name}`
      : item?.group_name;

    const conversationItem = {
      conversationId: item?.id || item?.label,
      sourceType: dmCategory === "groups" ? "group" : "direct",
      sourceId: item?.id || item?.label,
      title: title || "user",
      avatar: item?.profile_url || item?.group_image,
      userId: item?.contact_ref_id || item?.id,
    };
    // console.log("alal", conversationItem)
    const existingConversation = filteredConversationsList?.find(
      (conv) =>
        conv?.sourceId == conversationItem?.userId && conv?.conversation_id
    );

    if (existingConversation) {
      console.log("Existing conversation found:", existingConversation);

      const updatedConversationItem = {
        ...conversationItem,
        conversationId: existingConversation?.conversation_id,
      };

      dispatch(setCurrentConversation(updatedConversationItem));

      if (dmCategory === "groups") {
        dispatch(
          getGroupMessages({ id: existingConversation?.conversation_id })
        );
        dispatch(getGroupMembers(updatedConversationItem?.sourceId));
      } else {
        dispatch(
          getDirectMessages({ id: existingConversation?.conversation_id })
        );
      }
    } else {
      console.log("No existing conversation, creating new one");

      if (dmCategory === "groups") {
        // Dispatch createGroupConversation API 
        //  body: JSON.stringify({
        //         groupId: activeConversation?.id,
        //         conversation_type: "group",
        //       }),
        const  payload={
            groupId:conversationItem?.userId,
            conversation_type: "group"

        }
        // console.log("iamfromgroup", payload)
        dispatch(
          createGroupConversationId(payload)
        ).then((result) => {
            console.log("IamGroup", result)
          if (result?.payload && result?.payload?.conversationId) {
            const newConversationItem = {
              ...conversationItem,
              conversationId: result?.payload?.conversationId,
            };

            dispatch(setCurrentConversation(newConversationItem));
            dispatch(getConversationsList());
            dispatch(
              getGroupMessages({ id: newConversationItem?.conversationId })
            );
            dispatch(getGroupMembers(newConversationItem?.sourceId));
          }
        });
      } else {
        // Dispatch createDirectConversation API call
        //  body: JSON.stringify({
        //         receiver_id: activeConversation?.payload?.contact_ref_id,
        //         conversation_type: "direct",
        //       }),
       const  payload={
            receiver_id:conversationItem?.userId,
            conversation_type: "direct"

        }
        dispatch(
          createDirectConversationId(payload)
        ).then((result) => {
            // console.log("Iam result", result)
          if (result?.payload && result?.payload?.conversationId) {
            const newConversationItem = {
              ...conversationItem,
              conversationId: result?.payload?.conversationId,
            };

            dispatch(setCurrentConversation(newConversationItem));
            dispatch(getConversationsList());
            dispatch(
              getDirectMessages({ id: newConversationItem?.conversationId })
            );
          }
        });
      }
    }

    // Close the DM sheet
    setOpenDm(false);

    // Reset states
    setDmUserId(null);
    setDmGroupId(null);
    setDmTarget(null);
    setDmText("");
    setDmCategory("people");
  };

  return (
    <div>
      <Sheet
        open={openDm}
        onOpenChange={(value) => {
          setOpenDm(value);
          if (!value) {
            setDmUserId(null);
            setDmGroupId(null);
            setDmTarget(null);
            setDmText("");
            setDmCategory("people");
          }
        }}
      >
        <SheetContent
          side="left"
          className="z-[999] w-[400px] sm:w-[420px] bg-[white] text-[#e9edef] rounded-xl mt-24 ml-20 p-0 pt-4 pb-4"
        >
          <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-4 text-sm">
            <div className="flex gap-2">
              {[
                { key: "people", label: "People" },
                { key: "groups", label: "Groups" },
              ].map((tab) => {
                const active = dmCategory === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => {
                      if (dmCategory === tab.key) return;
                      setDmCategory(tab.key);
                      if (tab.key === "groups") {
                        setDmUserId(null);
                      } else {
                        setDmGroupId(null);
                      }
                      setDmTarget(null);
                    }}
                    className={`rounded-full px-3 py-1 text-xs transition ${
                      active
                        ? "bg-[#0044C6] text-[white]"
                        : "bg-[#f4f7fe] text-[#d1d7db] hover:bg-[#f4f7fe] text-[black]"
                    }`}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <div className="flex-1 min-h-0">
              {/* Updated div with scrollbar hidden */}
              <div
                className="h-[70vh] overflow-y-auto p-1"
                style={{
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <style>
                  {`
                    .h-\\[90vh\\].overflow-y-auto::-webkit-scrollbar {
                      display: none;
                      width: 0;
                      height: 0;
                    }
                  `}
                </style>
                {(() => {
                  const isGroupCategory = dmCategory === "groups";
                  const items = isGroupCategory
                    ? ContactGroups
                    : Connectedcontact;
                  if (!items.length) {
                    return (
                      <div className="text-center text-xs text-[black] py-4">
                        No options available.
                      </div>
                    );
                  }
                  return (
                    <ul className="space-y-2">
                      {items?.map((entry) => {
                        console.log("I am Entry", entry);
                        const fullname = entry?.first_name
                          ? `${entry?.first_name} ${entry?.last_name}`
                          : entry?.group_name;
                        const id = entry?.id || entry?.label;
                        const name = fullname || "user";
                        const subtitle = isGroupCategory
                          ? entry?.label
                          : entry?.email;
                        const email = entry?.email;
                        const avatarSeed =
                          entry?.profile_url || entry?.group_image;
                        const active = isGroupCategory
                          ? dmGroupId === id
                          : dmUserId === id;
                        const handleSelect = () => {
                          if (isGroupCategory) {
                            setDmGroupId(id);
                            setDmUserId(null);
                          } else {
                            setDmUserId(id);
                            setDmGroupId(null);
                            setProfileEmail(email);
                          }
                          setDmTarget(name);
                          setDmText("");
                          setProfileEmail(email);
                        };
                        return (
                          <li key={id}>
                            <button
                              type="button"
                              onClick={handleSelect}
                              className={`flex w-full items-center gap-2 rounded-xl border border-transparent px-2 py-2 text-left transition ${
                                active
                                  ? "border-[#0044C6] bg-[#8696a0]"
                                  : "hover:bg-[#f4f7fe]/60"
                              }`}
                            >
                              <Avatar className="h-9 w-9">
                                <AvatarImage
                                  src={
                                    avatarSeed ||
                                    "https://static.vecteezy.com/system/resources/previews/009/292/244/non_2x/default-avatar-icon-of-social-media-user-vector.jpg"
                                  }
                                  alt={name}
                                  referrerPolicy="no-referrer"
                                />
                              </Avatar>
                              <div className="min-w-0 flex-1">
                                <div className="truncate text-sm font-medium text-[black]">
                                  {name}
                                </div>
                                {subtitle && (
                                  <div className="text-[11px] text-[black]">
                                    {subtitle}
                                  </div>
                                )}
                              </div>
                              {/* Message button that triggers handleStartChat */}
                              <Button
                                type="button"
                                size="sm"
                                className="text-xs px-3 py-1 rounded-full transition bg-[#0044C6] text-white hover:bg-[#0039a8] shadow-none"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent triggering the parent button
                                  handleStartChat(entry);
                                }}
                              >
                                Message
                              </Button>
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  );
                })()}
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
